import { VFC } from "types";

interface ModalProps {
	title: string | null;
	onClose: () => void;
	show: boolean;
	children: React.ReactNode;
	size: "sm" | "lg" | "xl" | "full";
	position: "center" | "top";
}

const Modal: VFC<ModalProps> = ({ show, title, size, onClose, children, position = "center" }) => {
	if (!show) {
		return null;
	}
	return (
		<div className={`modal ${show ? "open" : ""} ${position === "top" ? "modal--top" : ""}`}>
			<span className="modal__backdrop"></span>
			<div className={`modal__container modal__container--${size}`}>
				<span className="modal__close" onClick={() => onClose()}>
					<span className="icon-new icon-blue icon-cross icon-12" />
				</span>
				{title && <div className="modal__title">{title}</div>}
				<div className="modal__body">{children}</div>
			</div>
		</div>
	);
};

export default Modal;
